import { render } from "./StockTakingDetail.vue?vue&type=template&id=20367471&scoped=true"
import script from "./StockTakingDetail.vue?vue&type=script&lang=js"
export * from "./StockTakingDetail.vue?vue&type=script&lang=js"

import "./StockTakingDetail.vue?vue&type=style&index=0&id=20367471&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20367471"],['__file',"src/views/h5/common/stock/stockTaking/StockTakingDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20367471"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20367471', __exports__)) {
    api.reload('20367471', __exports__)
  }
  
  module.hot.accept("./StockTakingDetail.vue?vue&type=template&id=20367471&scoped=true", () => {
    api.rerender('20367471', render)
  })

}


export default __exports__